/**
 * Волна B (docs/MIGRATION_ROUTER.md §5). Было: <CacheDataRoute path='/app'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import AppLanding from '@routes/AppLanding';

export const Route = createFileRoute('/app')({
  staticData: { layout: { landingFooter: true } },
  component: () => (
    <CacheDataRoute component={AppLanding} path='/app' />
  )
});
